import React from 'react';

import { NoValue } from '@folio/stripes/components';

import {
  ASSIGN_TASK_FIELDS,
  TEAM_FIELDS,
} from '../constants';

export const getFormattedAssigned = (data) => {
  if (data[ASSIGN_TASK_FIELDS.TEAM]?.[TEAM_FIELDS.NAME]) {
    if (data[ASSIGN_TASK_FIELDS.ASSIGNED_USER_NAME]) {
      return `${data[ASSIGN_TASK_FIELDS.TEAM][TEAM_FIELDS.NAME]}, ${data[ASSIGN_TASK_FIELDS.ASSIGNED_USER_NAME]}`;
    }

    return data[ASSIGN_TASK_FIELDS.TEAM][TEAM_FIELDS.NAME];
  }

  if (data[ASSIGN_TASK_FIELDS.ASSIGNED_USER_NAME]) {
    return data[ASSIGN_TASK_FIELDS.ASSIGNED_USER_NAME];
  }

  return <NoValue />;
};
